<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        <span>بارگذاری تصویر برای  </span> <span class="text-bold">{{ customerInfo.Cs_Name }}</span>
        <q-badge color="red" text-color="white" :label="customerInfo.Cs_Code"/>
        <template v-slot:action>
          <q-btn icon="close" flat round padding="none" v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-actions align="center">
      <q-btn label="مشاهده تصاویر" icon="visibility" color="indigo" text-color="white" @click="directoryListing"/>
    </q-card-actions>
    <q-card-actions>
      <q-uploader
          :factory="factoryFn"
          ref="uploader"
          @uploaded="onUploaded"
          @finish="onUploadFinished"
          method="POST"
          @rejected="onRejected"
          label="بارگذاری تصویر در سرویس فایل"
          bordered
          multiple
          max-file-size="100000000"/>
    </q-card-actions>
    <q-card-section v-for="(item, index) in files" :key="index" class="no-padding">
      <q-btn color="indigo" flat :label="item" @click="downloadAttachment(item)"/>
    </q-card-section>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "UploadCustomerProfileImages",
  components: {},
  props: {
    customerInfo: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      files: []
    }
  },
  methods: {
    ...mapActions({
      downloadFile: 'Orders/downloadFile',
      directoryList: 'Orders/directoryList'
    }),
    factoryFn() {
      return {
        url: `${this.$store.state.baseUrl}/upload_customer_profile_files/CustomersProfile/${this.customerInfo.Cs_Code}`,
        method: 'POST',
        headers: [
          {name: 'Authorization', value: `${this.$store.state.jwtType} ${this.$store.state.accessToken}`}
        ]
      }
    },
    onUploaded() {
    },
    onUploadFinished() {
      this.$emit('uploaded-finish', {filename: this.fileName, fileKind: this.fileKind})
    },
    onRejected(rejectedEntries) {
      console.log(rejectedEntries)
    },
    downloadAttachment(filename) {
      this.downloadFile(
          {
            filePath: `/CustomersProfile/${this.customerInfo.Cs_Code}/${filename}`,
          }).then(async (res) => {
        await this.openURL(res.data.publicLink)
      })
    },
    directoryListing() {
      this.downloadFile(
          {
            filePath: `/CustomersProfile/${this.customerInfo.Cs_Code}`,
          }).then(async (res) => {
        await this.openURL(res.data.publicLink)
      })
    }
  },
  computed: {},
  watch: {},
  created() {

  }
}
</script>

<style scoped>

</style>